module.exports = __webpack_public_path__ + "static/Candida-Brito-14bb91d36b6782c4198b770e6636df9e.jpeg";